<div class="wrapper">

  <!-- <div class="preloader mt-2 mb-2 d-none d-sm-block">
    <img class="logo1" src="https://prod-cdn.preprod.co-vin.in/logo.svg" alt="emblem"  height="60" width="60" />
    <img class="logo2" src="https://prod-cdn.preprod.co-vin.in/cowin-login-logo.png" alt="logo" class="cowinlogo"/>

  </div>  -->





  <div class="customdashboardblock">
    <app-header class="lang-{{currLang}}" ></app-header>

<div class="cutomdashboardTab lang-{{currLang}}" id="skip_to_main" (scroll)="onWindowScroll($event);">

 <!-- <mat-tab-group (selectedTabChange)="loadReportByTab($event?.tab?.textLabel)" disableRipple mat-align-tabs="end" animationDuration="0ms">
  <mat-tab label="Dashboard" style="color:#000;">
 <app-main-dashboard #mainDashboard></app-main-dashboard>
  </mat-tab>
  <mat-tab label="Registration">
    <app-registration-dashboard #regDashboardRprt></app-registration-dashboard>
  </mat-tab>

  <mat-tab label="Vaccination">
    <app-vaccination-dashboard #vaccDashboardRprt></app-vaccination-dashboard>
  </mat-tab>
</mat-tab-group> -->
<!-- <app-main-dashboard #mainDashboard ></app-main-dashboard> -->
<app-new-main-dashboard newmainDashboard></app-new-main-dashboard>
<!-- <tabset Class=" cm-custom-tabs clearfix" disableRipple  animationDuration="0ms">
  <tab heading="Dashboard" id="tab1" style="color:#000;" (selectTab)="loadReportByTab('Dashboard')">
    <app-main-dashboard #mainDashboard ></app-main-dashboard></tab>
  <tab  heading="Registration" (selectTab)="loadReportByTab('Registration')">  <app-registration-dashboard #regDashboardRprt></app-registration-dashboard></tab>
  <tab  heading="Vaccination" (selectTab)="loadReportByTab('Vaccination')"><app-vaccination-dashboard #vaccDashboardRprt></app-vaccination-dashboard></tab>
</tabset> -->


</div>


  </div>
  <!-- <div class="col-md-12 ">
    <nav *ngIf="breadCrumbArr.length > 0" aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb_dashboard">
        <li *ngFor="let b of breadCrumbArr; let isLast=last;"
        class="breadcrumb-item"
        [ngClass]="{'active' : isLast}"
        >
        <a *ngIf="!isLast" (click)="headerTextLbl= b.type;nextLevel(b.type, state_id, district_id)">{{b.name}}</a>
        <a *ngIf="isLast">{{b.name}}</a>
      </li>
      </ol>
    </nav>
  </div> -->

  <!-- <div class="content-wrapper">
    <div class="content-header">
      <div class="container-fluid">

      </div>
    </div>
    <section class="content">
      <div class="container-fluid">

        <div class="row">
          <div class="col-lg-3 cardblockcls col-6 margin-b">
            <div class="small-box bg-white dash-box cm-site-conduct-box">
              <div class="icon">

                <img src="assets/images/building.png" alt="sites" class="img-fluid img_icon"/>
              </div>
              <div class="inner innerbox">

                <p class="fontnormal titlemob">Sites Conducting Vaccination</p>
                <h3> <span class="fontnormal cls_today"></span>{{topBlockReport?.sites?.total| numberFormat}}</h3>

                <div class="row m-0 r-0 w-100">
                  <div class="col pl-0">
                    <small class="text-muted">Government</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.sites?.govt | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Private</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.sites?.pvt | numberFormat}}</p>

                  </div>
              </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 cardblockcls col-6 margin-b">
            <div class="small-box bg-white cm-planned-vac-box">
              <div class="icon icon-bg-session">
                <span class="icon-session"></span>
              </div>
              <div class="inner innerbox">

                <p class="fontnormal titlemob">Planned Vaccination Capacity</p>
                <h3> <span class="fontnormal cls_today"></span>{{topBlockReport?.sessions?.total | numberFormat}}</h3>

                <div class="row m-0 r-0 w-100">
                  <div class="col pl-0">
                    <small class="text-muted">Government</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.sessions?.govt | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Private</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.sessions?.pvt | numberFormat}}</p>

                  </div>
              </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 cardblockcls col-6 margin-b" *ngIf="!this.state_id">
            <div class="small-box bg-white dash-box cm-reg-box">
              <div class="row">


                <div class="icon icon-bg-beneficiary">

                  <img src="assets/images/group.png" alt="sites" class="img-fluid img_icon"/>
                </div>



            </div>
              <div class="inner innerbox" >
                <p class="small todayvalue  text-right mb-0"><span class="fontnormal">Today : </span> <strong class="greencolor">{{topBlockReport?.registration?.today | numberFormat}}</strong></p>
                <p class="fontnormal titlemob">Total Registrations</p>
                <h3>{{topBlockReport?.registration?.total | numberFormat}}</h3>

                <div class="row m-0 r-0 w-100 csutomcsls cm-t-registration">
                  <div class="col pl-0">
                    <small class="text-muted txt_male">Male</small>
                      <p class="d-block mb-0 font-weight-bold font-2 p_male">{{topBlockReport?.registration?.male | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Female</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.registration?.female | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Others</small>
                    <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.registration?.others | numberFormat}}</p>

                </div>
              </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 cardblockcls col-6 margin-b" *ngIf="this.state_id">
            <div class="small-box bg-white dash-box ">
              <div class="row">
                <div class="icon icon-bg-beneficiary">

                  <img src="assets/images/group.png" alt="sites" class="img-fluid img_icon"/>
                </div>


            </div>
              <div class="inner innerbox" >
                <p class="small todayvalue  text-right mb-0"><span class="fontnormal">Today : </span> <strong class="greencolor">{{topBlockReport?.registration?.today | numberFormat}}</strong></p>
                <p class="fontnormal titlemob">Total Appointments</p>
                <h3>{{topBlockReport?.registration?.total | numberFormat}}</h3>

                <div class="row m-0 r-0 w-100 csutomcsls">
                  <div class="col pl-0">
                    <small class="text-muted txt_male">Male</small>
                      <p class="d-block mb-0 font-weight-bold font-2 p_male">{{topBlockReport?.registration?.male | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Female</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.registration?.female | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Others</small>
                    <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.registration?.others | numberFormat}}</p>

                </div>
              </div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 cardblockcls col-6 margin-b">
            <div class="small-box bg-white cm-vaccinated-box">
              <div class="icon icon-bg-vaccine">
                <span class="icon-vaccine"></span>
              </div>
             <div class="inner innerbox">
                <p class="small todayvalue  text-right mb-0"> <span class="fontnormal">Today : </span> <strong class="greencolor">{{topBlockReport?.vaccination?.today | numberFormat}}</strong></p>
                <p class="fontnormal titlemob">Total Vaccinated</p>
                <h3>{{topBlockReport?.vaccination?.total | numberFormat}}</h3>

                <div class="row m-0 r-0 w-100 csutomcsls cm-t-vaccinated">
                  <div class="col pl-0">
                    <small class="text-muted">Male</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.vaccination?.male | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Female</small>
                      <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.vaccination?.female | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted">Others</small>
                    <p class="d-block mb-0 font-weight-bold font-2">{{topBlockReport?.vaccination?.others | numberFormat}}</p>

                </div>
              </div>
              </div>
            </div>
          </div>

        </div>


        <div class="row">

          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Vaccination Time Line - {{todaysdate | date: 'dd/MM/yyyy'}}
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeCNVS"  id="realtime" width="600" height="200"></canvas>
                <ng-template #mobileRealtimeCNVS>
                  <canvas id="realtime" width="600" height="400"></canvas>

                </ng-template>
              </div>
            </div>
          </section>
          <section class="col-lg-6 connectedSortable" *ngIf="!this.state_id">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Last 7 Days Registration
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas id='lastSevenReg' width="400" height="133"></canvas>
              </div>
            </div>
          </section>
          <section class="col-lg-6 connectedSortable" *ngIf="this.state_id">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Last 7 Days Appointments
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas id='lastSevenAppointment' width="400" height="133"></canvas>
              </div>
            </div>
          </section>
        </div>
        <div class="row">
          <section class="col-lg-3 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                 Vaccination - Category
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                  <canvas *ngIf="!deviceService.isMobile() else genderPieCanvas"  id='total-vaccinated-gender' width="300" height="133"></canvas>
                  <ng-template #genderPieCanvas>
                    <canvas id="total-vaccinated-gender" width="600" height="400"></canvas>
                  </ng-template>


                  <canvas *ngIf="!deviceService.isMobile() else materialPieCanvas"  id='material-used' width="300" height="133"></canvas>
                  <ng-template #materialPieCanvas>
                    <canvas id="material-used" width="600" height="400"></canvas>
                  </ng-template>
              </div>
            </div>
          </section>

          <section class="col-lg-3 connectedSortable">

            <div class="card">
              <div class="card-header">

                  <h3 class="card-title blocktitle" style="width:100%;">

                    {{tableheader}}

                  </h3>

              </div>
              <div class="card-body tbl_card nopading">
                <div id="data-list" class="slim" style="height: 275px; overflow: auto;">
                  <table class="table tblstates">
                    <tbody class="table-body rep-tb-body">

                        <tr *ngFor="let benData of getBeneficiariesGroupBy">
                        <td class="title" style="width: 80%; font-size: 13px; color: #007bff;; font-weight: 500;">{{benData.title}}</td>
                        <td style="width: 30%;font-size: 15px;color: #12226f;font-weight: 600;" class="text-right">{{benData.total | numberFormat}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
        </section>
          <section class="col-lg-6 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  Last 7 Days Vaccination
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else mobileLast30days"  id="vaccine-last-30" width="600" height="240"></canvas>
                <ng-template #mobileLast30days>
                  <canvas id="vaccine-last-30" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
          </section>
        </div>

  </div>
  <footer class="main-footer">
    Copyright &copy; 2021 COVID. All Rights Reserved
    <div class="float-right d-none d-sm-inline-block">

    </div>
  </footer>

  <aside class="control-sidebar control-sidebar-dark">
  </aside>
</div> -->
<app-footer class="lang-{{currLang}}" ></app-footer>

<aside class="control-sidebar control-sidebar-dark">
</aside>


<router-outlet></router-outlet>
